import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DisplayNotificationService } from 'src/app/shared/services/common/notification.service';
import { ReadConfigService } from 'src/app/shared/services/common/read-config.service';
import { UsersService } from 'src/app/shared/services/common/users.service';
import { EmployeesService } from 'src/app/shared/services/employees/employees.service';

@Component({
  selector: 'app-pending-detailed-view',
  templateUrl: './pending-detailed-view.component.html',
  styleUrls: ['./pending-detailed-view.component.css']
})
export class PendingDetailedViewComponent implements OnInit {
  personInfo: any = {};
  enrollmentInfo: any = {};
  contactInfo: any = {};
  userLocations: any;
  userSystems: any;
  config: any;
  dataLoading: boolean;
  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.dataLoading = true;
      this.getLoactionAndSystem(dataItem);
    }
  }

  constructor(
    private usersService: UsersService,
    private employeesService: EmployeesService,
    private readConfigService: ReadConfigService,
    private notificationService: DisplayNotificationService
  ) {
    this.config = this.readConfigService.getEnrollmentMemberText();
  }

  ngOnInit(): void {
  }

  getLoactionAndSystem(data: any) {
    const inputData = { userInfo: this.usersService.UserInfo() };
    this.employeesService.getEnrollmentInput(inputData).subscribe((response: any) => {
      if (response && response.success && response.locations && response.locations.length > 0
        && response.systemCodes && response.systemCodes.length > 0) {
        response.locations.forEach(element => {
          element.name = element.code.concat('-', element.name);
        });
        this.userLocations = response.locations.sort((a: any, b: any) => a.code - b.code);
        this.userSystems = response.systemCodes;
      } else {
        this.notificationService.setErrorNotification();
      }
      this.getPendingEnrollmentDetails(data);
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.dataLoading = false;
        this.notificationService.setErrorNotification();
      })
  }

  getPendingEnrollmentDetails(dataItem: any) {
    this.personInfo = {};
    this.enrollmentInfo = {};
    this.contactInfo = {};
    const inputData = { userInfo: this.usersService.UserInfo(), enrollmentId: dataItem.id, isDetailView: true };
    this.employeesService.getEmploymentInfo(inputData).subscribe((response: any) => {
      if (response && response.statusCode === 200) {
        this.personInfo = response.personalInfo;
        if (response.scheduleInfo !== null) {
          response.scheduleInfo.locationName = this.userLocations.find(ele => ele.code === response?.scheduleInfo?.locationCode);
          response.scheduleInfo.systemName = this.userSystems.find(ele => ele.code === response?.scheduleInfo?.systemCode);
          this.enrollmentInfo = response.scheduleInfo;
        }
        this.contactInfo = response.contactInfo;
      } else {
        this.notificationService.setErrorNotification();
      }
      this.dataLoading = false;
    },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.dataLoading = false;
        this.notificationService.setErrorNotification();
      });
  }

}
